import api from '../api/axios';

/**
 * The one post-login path, shared by password, OTP and Microsoft sign-in.
 *
 * Extracted from Landing so an SSO callback lands a user in exactly the same
 * state as a password login — the alternative was a second copy that would
 * drift on onboarding or approval routing.
 *
 * @param {object} data     the standard login response body
 * @param {object} handlers { login, syncSessionFromServer, navigate }
 * @returns {Promise<{needsOnboarding: boolean}>}
 */
export async function completeLogin(data, { login, syncSessionFromServer, navigate }) {
  const needsOnboarding = Boolean(data.needsOnboarding);

  login(data.token, data.role, {
    id: data.userId,
    email: data.email,
    role: data.role,
    status: data.status,
    needsOnboarding,
    permissions: Array.isArray(data.permissions) ? data.permissions : [],
  });

  try {
    const { data: me } = await api.get('/auth/me');
    syncSessionFromServer(me);
  } catch {
    /* AuthProvider bootstrap will resync on next load */
  }

  // A pending account has to finish onboarding first — that is where it picks
  // the department whose managers will approve it.
  const destination = needsOnboarding
    ? '/onboarding'
    : data.status && data.status !== 'approved'
      ? '/pending-approval'
      : '/dashboard';

  setTimeout(() => navigate(destination), 80);
  return { needsOnboarding, destination };
}

export default completeLogin;
